export default __webpack_public_path__ + "static/media/0034.b8668599.png";